import EstablishmentContactForm from "./EstablishmentContactForm";

type ProjectManagerFormProps = {
    goto: (step: number) => void;
    nextStep: number;
    profilId: string;
};

export default function EstablishmentProjectManagerForm({
    goto,
    nextStep,
    profilId,
}: ProjectManagerFormProps) {
    const title = "Coordonnées du responsable projet de qualification";
    const subTitle =
        "Renseignez les informations des personnes à contacter en cas de besoin";
    const jobTitle = "Le responsable projet de qualification";
    return (
        <EstablishmentContactForm
            goto={() => goto(nextStep)}
            nextStep={nextStep}
            profilId={profilId}
            title={title}
            subTitle={subTitle}
            jobTitle={jobTitle}
        />
    );
}
